import { render, staticRenderFns } from "./feedItem.vue?vue&type=template&id=dc0de3a2&scoped=true&"
import script from "./feedItem.vue?vue&type=script&lang=js&"
export * from "./feedItem.vue?vue&type=script&lang=js&"
import style0 from "./feedItem.vue?vue&type=style&index=0&id=dc0de3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0de3a2",
  null
  
)

export default component.exports